import React, { useState, useEffect, useCallback } from 'react';
import { getAssignedTasks } from '../Services/masterService';

function LogisticsDashboard() {
    const [allTasks, setAllTasks] = useState([]);

    const stats = [
        { label: "Tasks Deliveries", value: "24", icon: "🚚" }, // FaTruck
        { label: "Total Clients", value: "8", icon: "📦" },    // FaWarehouse
        { label: "Tasks Completed", value: "1,200", icon: "📊" }, // FaChartLine
        // { label: "On-Time Rate", value: "98%", icon: "✅" }, // FaCheckCircle
    ];

    const [taskCounts, setTaskCounts] = useState({
        new_request: 0,
        in_progress: 0,
        completed: 0,
    });

    const fetchTasks = useCallback(async () => {
        const storedUser = localStorage.getItem('user');
        const userInfo = JSON.parse(storedUser)
        try {
            const response = await getAssignedTasks({ logisticId: userInfo.id });
            if (response.status === 1) {
                const counts = {
                    new_request: 0,
                    in_progress: 0,
                    completed: 0,
                };

                response.data.forEach(task => {
                    switch (task.status) {
                        case 'NEW_REQUEST':
                            counts.new_request += 1;
                            break;
                        case 'ASSIGNED':
                        case 'ACCEPTED':
                        case 'IN_PROGRESS':
                        case 'COLLECTED':
                        case 'RECEIVED':
                        case 'HANDOVERED':
                            counts.in_progress += 1;
                            break;
                        case 'COMPLETED':
                            counts.completed += 1;
                            break;
                        default:
                            break; // other statuses like CANCELLED or REJECTED are ignored
                    }
                });

                setTaskCounts(counts);
                console.log('taskCounts', taskCounts)
            } else {
                console.error("Failed to fetch tasks");
                setAllTasks([]);
            }
        } catch (error) {
            console.log("Network error fetching tasks:", error);
        }
    }, []);

    useEffect(() => {
        fetchTasks();
    }, [fetchTasks]);

    return (
        <div className="bg-gray-50">
            {/* Main Content Wrap */}
            <div className="main-wrap">
                <div className="container">
                    {/* Hero Section */}
                    <header className="bg-green-600 rounded-lg shadow-xl p-10 mb-12 text-center relative overflow-hidden">
                        {/* Background pattern/overlay for visual interest */}
                        <div className="absolute inset-0 bg-gradient-to-br from-green-500 to-green-800 opacity-90 rounded-lg"></div>
                        <div className="relative z-10">
                            <h1 className="text-2xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
                                Streamline Your Logistics Operations
                            </h1>
                            <p className="text-green-100 text-md md:text-xl mb-8 max-w-2xl mx-auto">
                                Manage requests, track samples, and optimize routes with unparalleled efficiency.
                            </p>
                            <button className="bg-white text-green-700 hover:bg-green-100 font-bold py-3 px-8 rounded-full text-lg shadow-lg transform hover:scale-105 transition duration-300">
                                <a className='text-green-700' href="/logistics-task">
                                    Task Management
                                </a>
                            </button>
                        </div>
                    </header>

                    {/* Statistics Cards */}
                    <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 mb-12">

                        {/* Pending Tasks */}
                        <div className="bg-white rounded-lg shadow-lg p-6 text-center border-b-4 border-green-500 transform hover:shadow-xl transition duration-300">
                            <div className="text-5xl mb-3 text-green-600">🕒</div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Pending Task</h3>
                            <p className="text-2xl font-bold text-green-700">
                                {taskCounts.in_progress}
                            </p>
                        </div>

                        {/* Completed Tasks */}
                        <div className="bg-white rounded-lg shadow-lg p-6 text-center border-b-4 border-green-500 transform hover:shadow-xl transition duration-300">
                            <div className="text-5xl mb-3 text-green-600">📦</div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Completed Tasks</h3>
                            <p className="text-2xl font-bold text-green-700">
                                {taskCounts.completed}
                            </p>
                        </div>

                        {/* New Requests Today */}
                        {/* <div className="bg-white rounded-lg shadow-lg p-6 text-center border-b-4 border-green-500 transform hover:shadow-xl transition duration-300">
                            <div className="text-5xl mb-3 text-green-600">➕</div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">New Requests Today</h3>
                            <p className="text-2xl font-bold text-green-700">
                                {taskCounts.new_request}
                            </p>
                        </div> */}

                        {/* Last Service Date */}
                        {/* <div className="bg-white rounded-lg shadow-lg p-6 text-center border-b-4 border-green-500 transform hover:shadow-xl transition duration-300">
                            <div className="text-5xl mb-3 text-green-600">🗓️</div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Last Service Date</h3>
                            <p className="text-2xl font-bold text-green-700">
                                {allTasks.length > 0
                                    ? new Date(
                                        allTasks.reduce((latest, task) =>
                                            new Date(task.createdAt) > new Date(latest.createdAt) ? task : latest
                                        ).createdAt
                                    ).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
                                    : "-"
                                }
                            </p>
                        </div> */}

                    </section>

                    {/* Recent Activities / Quick Links */}

                </div>
            </div>


        </div>
    );
}

export default LogisticsDashboard;